const uk = {
  brand: "E2 Care",
  tagline: "Спокійний, поєднаний догляд.",
  nav_dashboard: "Панель",
  nav_residents: "Пацієнти",
  nav_patients: "Пацієнти",
  nav_rooms: "Кімнати",
  nav_devices: "Пристрої",
  nav_events: "Події",
  nav_alerts: "Сповіщення",
  nav_users: "Команда",
  nav_settings: "Налаштування",
  nav_admin: "Адміністрування",
  nav_signout: "Вийти",
  topbar_search_placeholder: "Пошук пацієнтів, кімнат, пристроїв…",
  admin_super_only: "Лише суперадміністратори можуть керувати організаціями.",
  admin_admin_only: "Лише адміністратори мають доступ до цієї сторінки.",
  admin_tab_orgs: "Організації",
  admin_tab_users: "Користувачі",
  admin_tab_patients: "Пацієнти",
  admin_tab_rooms: "Кімнати",
  admin_tab_buildings: "Будівлі",
  admin_tab_devices: "Пристрої",
  admin_tab_alerts: "Сповіщення",
  admin_tab_qa: "Тестові інструменти",
  admin_delete: "Видалити",
  admin_no_orgs_yet: "Ще немає організацій.",
  admin_field_name: "Ім’я",
  admin_field_email: "Ел. пошта",
  admin_field_phone: "Телефон",
  admin_field_password: "Пароль",
  admin_field_role: "Роль",
  admin_field_type: "Тип",
  admin_field_timezone: "Часовий пояс",
  admin_field_address: "Адреса",
  admin_field_status: "Статус",
  admin_field_organization: "Організація",
  admin_password_keep: "Залиште порожнім, щоб зберегти поточний",
  admin_field_birth_date: "Дата народження",
  admin_field_room: "Кімната",
  admin_field_room_none: "Не призначено",
  admin_field_photo: "URL фото",
  admin_field_photo_hint: "Вставте публічний URL зображення — повне завантаження у версії 2.",
  admin_field_notes: "Нотатки доглядальника",
  admin_field_emergency_contact: "Основний екстрений контакт",
  admin_field_ec_name: "Ім’я",
  admin_field_ec_phone: "Телефон",
  admin_field_ec_relationship: "Спорідненість",
  admin_field_mac: "MAC-адреса",
  admin_field_firmware: "Прошивка",
  admin_field_assignment: "Призначено",
  admin_field_assigned_room: "Призначена кімната",
  admin_field_assigned_patient: "Призначений пацієнт",
  admin_field_assigned_hint: "Необов’язково. Датчики зазвичай прикріплюють до кімнати, браслети — до пацієнта.",
  admin_field_sensor_target: "Встановлено на",
  admin_field_sensor_target_hint: "Повідомляє системі, чи цей датчик стежить за дверима, чи за вікном.",
  sensor_target_door: "Двері",
  sensor_target_window: "Вікно",
  sensor_target_unset: "Не налаштовано",
  admin_field_sensor_label: "Мітка датчика",
  admin_field_sensor_label_hint: "Зручна назва, що відображається у сповіщеннях і подіях — напр. «Вхідні двері», «Вікно ванної».",
  admin_field_building: "Будівля",
  admin_field_building_required: "Кімната має належати до будівлі.",
  room_openings: "Отвори",
  room_no_openings: "У цій кімнаті ще не встановлено датчиків дверей або вікон.",
  room_openings_summary: "{doors} {doorsLabel} · {windows} {windowsLabel}",
  opening_last_event: "Остання зміна",
  admin_field_description: "Опис",
  admin_field_severity: "Рівень важливості",
  admin_field_patient: "Пацієнт",
  admin_field_device: "Пристрій",
  admin_field_message: "Повідомлення",
  admin_orgs_title: "Організації",
  admin_orgs_sub: "Створюйте, редагуйте та архівуйте орендарів E2 Care.",
  admin_orgs_count: "організації",
  admin_org_new: "Нова організація",
  admin_org_new_title: "Нова організація",
  admin_org_edit_title: "Редагувати організацію",
  admin_org_created: "Організацію створено.",
  admin_org_updated: "Організацію оновлено.",
  admin_org_deleted: "Організацію заархівовано.",
  admin_org_delete_title: "Заархівувати організацію?",
  admin_org_delete_confirm: "Це приховає «{name}» зі списків. За потреби її можна відновити з бази даних.",
  admin_users_title: "Користувачі",
  admin_users_sub_super: "Керуйте всіма обліковими записами користувачів у всіх орендарів.",
  admin_users_sub_org: "Керуйте обліковими записами користувачів для {org}.",
  admin_user_new: "Новий користувач",
  admin_user_new_title: "Новий користувач",
  admin_user_edit_title: "Редагувати користувача",
  admin_user_created: "Користувача створено.",
  admin_user_updated: "Користувача оновлено.",
  admin_user_deleted: "Користувача заархівовано.",
  admin_user_delete_title: "Заархівувати користувача?",
  admin_user_delete_confirm: "«{name}» втратить доступ. Активні сеанси не завершуються.",
  admin_user_memberships: "Членство в організаціях",
  admin_patients_title: "Пацієнти",
  admin_patients_sub_super: "Керуйте всіма картками пацієнтів у всіх орендарів.",
  admin_patients_sub_org: "Керуйте картками пацієнтів у {org}.",
  admin_patient_new: "Новий пацієнт",
  admin_patient_new_title: "Новий пацієнт",
  admin_patient_edit_title: "Редагувати пацієнта",
  admin_patient_created: "Пацієнта створено.",
  admin_patient_updated: "Пацієнта оновлено.",
  admin_patient_deleted: "Пацієнта заархівовано.",
  admin_patient_delete_title: "Заархівувати пацієнта?",
  admin_patient_delete_confirm: "«{name}» буде приховано зі списків. Зв’язки з командою догляду та родиною збережено.",
  admin_rooms_title: "Кімнати",
  admin_rooms_sub_super: "Налаштовуйте кімнати у всіх орендарів.",
  admin_rooms_sub_org: "Налаштовуйте кімнати у {org}.",
  admin_room_new: "Нова кімната",
  admin_room_new_title: "Нова кімната",
  admin_room_edit_title: "Редагувати кімнату",
  admin_room_created: "Кімнату створено.",
  admin_room_updated: "Кімнату оновлено.",
  admin_room_deleted: "Кімнату заархівовано.",
  admin_room_delete_title: "Заархівувати кімнату?",
  admin_room_delete_confirm: "«{name}» буде приховано. Наявні пацієнти зберігають посилання assigned_room_id.",
  admin_devices_title: "Пристрої",
  admin_devices_sub_super: "Надавайте пристрої Moko у всіх орендарів.",
  admin_devices_sub_org: "Надавайте пристрої Moko у {org}.",
  admin_device_new: "Новий пристрій",
  admin_device_new_title: "Новий пристрій",
  admin_device_edit_title: "Редагувати пристрій",
  admin_device_created: "Пристрій створено.",
  admin_device_updated: "Пристрій оновлено.",
  admin_device_deleted: "Пристрій заархівовано.",
  admin_device_delete_title: "Заархівувати пристрій?",
  admin_device_delete_confirm: "Пристрій {mac} буде приховано. Минулі події та сповіщення залишаються в історії.",
  admin_buildings_title: "Будівлі",
  admin_buildings_sub_super: "Групуйте кімнати за фізичною будівлею / крилом у всіх орендарів.",
  admin_buildings_sub_org: "Групуйте кімнати за фізичною будівлею / крилом у {org}.",
  admin_building_new: "Нова будівля",
  admin_building_new_title: "Нова будівля",
  admin_building_edit_title: "Редагувати будівлю",
  admin_building_created: "Будівлю створено.",
  admin_building_updated: "Будівлю оновлено.",
  admin_building_deleted: "Будівлю заархівовано.",
  admin_building_delete_title: "Заархівувати будівлю?",
  admin_building_delete_confirm: "«{name}» буде приховано. Кімнати зберігають посилання corpus_id.",
  admin_qa_title: "Тестові інструменти",
  admin_qa_sub: "Впроваджуйте події / сповіщення, щоб перевірити панель, розсилання сповіщень і канали повідомлень без використання справжніх пристроїв Moko.",
  admin_qa_event_title: "Впровадити тестову подію",
  admin_qa_event_sub: "Симулює вебхук пристрою Moko. Бекенд запустить свій конвеєр розсилання сповіщень, ніби подія надійшла зі справжнього обладнання.",
  admin_qa_alert_title: "Впровадити тестове сповіщення",
  admin_qa_alert_sub: "Пропускає рівень подій і записує сповіщення напряму. Використовуйте для перевірки дзвіночка, списку та розсилання Slack/Telegram.",
  admin_qa_inject_event: "Впровадити подію",
  admin_qa_inject_alert: "Впровадити сповіщення",
  admin_qa_event_done: "Подію впроваджено. Слідкуйте за сторінкою Події та панеллю.",
  admin_qa_alert_done: "Сповіщення впроваджено. Слідкуйте за дзвіночком.",
  admin_qa_disclaimer: "Ці кінцеві точки слід вимкнути або позначити прапорцем у продакшені.",
  admin_alerts_title: "Політика сповіщень",
  admin_alerts_sub: "Правила сповіщень для всієї {org}. Застосовуються до кожного пацієнта цього орендаря.",
  admin_alerts_quiet_title: "Тихі години",
  admin_alerts_quiet_desc: "Визначте, коли ця організація перебуває в «нічному режимі». Корисно для тихішого маршрутування некритичних сповіщень.",
  admin_alerts_quiet_hint: "Час інтерпретується в локальному часовому поясі організації. Діапазон може переходити північ (напр. 22:00 → 06:00).",
  admin_alerts_night_start: "Ніч починається",
  admin_alerts_night_end: "Ніч закінчується",
  admin_alerts_load_failed: "Завантажити політику сповіщень",
  admin_alerts_save_failed: "Зберегти політику сповіщень",
  admin_alerts_saved: "Політику сповіщень збережено.",
  admin_alerts_clear_title: "Очистити активні сповіщення",
  admin_alerts_clear_desc: "Підтвердьте всі відкриті сповіщення цієї організації одним кліком.",
  admin_alerts_clear_hint: "Корисно після запланованого навчання або неправильно налаштованого датчика, що спричинив хвилю хибних спрацювань. Підтверджені сповіщення залишаються в історії.",
  admin_alerts_ack_all_button: "Підтвердити всі",
  admin_alerts_ack_all_title: "Підтвердити всі активні сповіщення?",
  admin_alerts_ack_all_confirm: "Це позначить як підтверджене кожне відкрите сповіщення в {org}. Цю дію не можна скасувати.",
  admin_alerts_ack_all_done: "Підтверджено {count} сповіщення.",
  admin_alerts_ack_all_done_generic: "Усі активні сповіщення підтверджено.",
  admin_alerts_ack_all_failed: "Підтвердити всі сповіщення",
  org_type_nursing_home: "Будинок престарілих",
  org_type_assisted_living: "Житло з підтримкою",
  org_type_hospital: "Лікарня",
  org_type_home_care: "Домашній догляд",
  role_admin: "Адміністратор",
  role_caregiver: "Доглядальник",
  role_family: "Родина",
  status_active: "активний",
  status_inactive: "неактивний",
  confirm: "Підтвердити",
  sign_in: "Увійти",
  sign_up: "Зареєструватися",
  email: "Ел. пошта",
  password: "Пароль",
  full_name: "Повне ім’я",
  create_account: "Створити обліковий запис",
  no_account: "Ще немає облікового запису?",
  have_account: "Вже маєте обліковий запис?",
  login_welcome: "З поверненням",
  login_sub: "Увійдіть, щоб продовжити моніторинг ваших підопічних.",
  register_welcome: "Приєднуйтесь до E2 Care",
  register_sub: "Створіть свій робочий простір доглядальника менш ніж за хвилину.",
  total_residents: "Пацієнти",
  active_devices: "Активні пристрої",
  open_alerts: "Відкриті сповіщення",
  offline_gateways: "Пристрої офлайн",
  falls_7d: "Падіння (7 дн)",
  sos_7d: "SOS (7 дн)",
  low_battery: "Низький заряд",
  critical_residents: "Критичні",
  status_ok: "Все гаразд",
  status_warning: "Увага",
  status_critical: "Критичний",
  status_online: "Онлайн",
  status_offline: "Офлайн",
  search: "Пошук",
  filter: "Фільтр",
  all: "Усі",
  refresh: "Оновити",
  loading: "Завантаження…",
  no_results: "Тут поки нічого немає.",
  view_profile: "Переглянути профіль",
  showing_n_of_m: "Показано {n} з {m}",
  load_more: "Завантажити ще",
  auto_refresh: "У реальному часі · автооновлення",
  auto_refresh_paused: "Призупинено (активне завантаження ще)",
  updated_just_now: "Оновлено щойно",
  updated_n_sec_ago: "Оновлено {n} с тому",
  updated_n_min_ago: "Оновлено {n} хв тому",
  acknowledge: "Підтвердити",
  acknowledged: "Підтверджено",
  ack_all: "Підтвердити всі",
  ack_all_confirm: "Підтвердити всі {count} активні сповіщення?",
  ack_all_running: "Підтвердження…",
  ack_all_done: "Підтверджено {count} сповіщень.",
  ack_all_partial: "{ok} підтверджено · {fail} не вдалося.",
  last_seen: "Востаннє в мережі",
  battery: "Батарея",
  signal: "Сигнал",
  firmware: "Прошивка",
  room: "Кв. / Кімната",
  age: "Вік",
  emergency_contact: "Екстрений контакт",
  notes: "Нотатки",
  assigned_devices: "Призначені пристрої",
  recent_events: "Останні події",
  timeline_24h: "Останні 24 години",
  delivery_status: "Статус доставки",
  acknowledged_by: "Підтверджено",
  dashboard_title: "Огляд будинку",
  dashboard_sub: "Швидкий огляд усього, що відбувається в будинках, за якими ви доглядаєте.",
  residents_title: "Пацієнти",
  residents_sub: "Люди, яких ви зараз моніторите.",
  devices_title: "Пристрої",
  devices_sub: "Датчики й теги.",
  devices_sub_admin: "Шлюзи, датчики й теги.",
  events_title: "Події наживо",
  events_sub: "Хронологічна стрічка з кожного підключеного пристрою.",
  alerts_title: "Сповіщення",
  alerts_sub: "Повідомлення, ескальовані до родини та доглядальників.",
  settings_title: "Налаштування",
  settings_sub: "Ваші вподобання та правила сповіщень.",
  users_title: "Команда",
  users_sub: "Доглядальники, родина й адміністратори з доступом.",
  falls_chart_title: "Падіння та SOS — останні 7 днів",
  recent_alerts_title: "Останні критичні сповіщення",
  no_alerts: "Немає відкритих сповіщень. Усі в безпеці.",
  event_fall: "Виявлено падіння",
  event_sos: "Натиснуто кнопку SOS",
  event_door_open: "Двері відчинено",
  event_door_close: "Двері зачинено",
  event_inactivity: "Тривала бездіяльність",
  event_low_battery: "Низький заряд",
  event_offline: "Пристрій офлайн",
  event_online: "Пристрій знову онлайн",
  event_heartbeat: "Сигнал активності",
  event_button_press: "Натиснуто кнопку",
  device_gateway: "Шлюз Bluetooth",
  device_door_sensor: "Датчик дверей",
  device_bracelet: "Браслет",
  device_unknown: "Невідомий пристрій",
  language: "Мова",
  notifications: "Сповіщення",
  quiet_hours: "Тихі години",
  escalation: "Політика ескалації",
  just_now: "щойно",
  min_ago: "хв тому",
  h_ago: "год тому",
  d_ago: "дн тому",
  demo_hint: "Демо-акаунт: admin@e2care.lv / Care2024!",
  open_menu: "Відкрити меню",
  close_menu: "Закрити меню",
  care_team: "Команда догляду",
  family_members: "Родина",
  no_caregivers: "Доглядальників ще не призначено.",
  no_family: "Членів родини ще не пов’язано.",
  add_caregiver: "Додати доглядальника",
  add_family: "Додати члена родини",
  select_user: "Виберіть користувача…",
  cancel: "Скасувати",
  add: "Додати",
  remove: "Видалити",
  save: "Зберегти",
  relationship: "Спорідненість",
  relationship_son: "Син",
  relationship_daughter: "Дочка",
  relationship_spouse: "Чоловік/дружина",
  relationship_other: "Інше",
  notify_via: "Сповіщати через",
  call_contact: "Зателефонувати контакту",
  view_resident: "Відкрити профіль",
  address: "Адреса",
  admin_only_section: "Інструменти адміністратора",
  rooms_title: "Кімнати",
  rooms_sub: "Кожна кімната під вашим наглядом — пацієнти, пристрої та поточний стан.",
  room_name: "Кімната",
  room_type: "Тип",
  room_type_private_room: "Окрема кімната",
  room_type_shared_room: "Спільна кімната",
  room_type_apartment: "Квартира",
  room_type_corridor: "Коридор",
  room_type_common_area: "Спільна зона",
  room_floor: "Поверх",
  room_state: "Поточний стан",
  door: "Двері",
  window: "Вікно",
  door_open_state: "Відчинено",
  door_closed_state: "Зачинено",
  door_unknown_state: "Невідомо",
  room_no_devices: "У цій кімнаті ще немає пристроїв.",
  room_no_patients: "До цієї кімнати ще не призначено пацієнтів.",
  room_patients: "Пацієнти в кімнаті",
  room_devices: "Пристрої в кімнаті",
  room_activity: "Хронологія активності",
  rooms_filter_all_types: "Усі типи",
  widget_active_alerts: "Активні сповіщення",
  widget_active_alerts_sub: "Критичні, невирішені та підтверджені",
  widget_patients_status: "Статус пацієнтів",
  widget_devices_health: "Стан пристроїв",
  widget_room_activity: "Активність кімнат",
  widget_recent_events: "Стрічка подій наживо",
  widget_connectivity: "Зв’язок",
  metric_critical: "Критичні",
  metric_unresolved: "Невирішені",
  metric_acknowledged_count: "Підтверджені",
  metric_total: "Усього",
  metric_active: "Активні",
  metric_online: "Онлайн",
  metric_offline: "Офлайн",
  metric_ota_pending: "OTA очікує",
  metric_battery_warn: "Низька батарея",
  metric_doors_open: "Відчинені двері",
  metric_windows_open: "Відчинені вікна",
  metric_signal_avg: "Сер. сигнал",
  metric_last_comm: "Останній зв’язок",
  metric_packets: "Пакети / год",
  view_all: "Переглянути всі",
  status_new: "Новий",
  status_acknowledged: "Підтверджений",
  status_resolved: "Вирішений",
  status_resolved_local: "Вирішено (локально)",
  resolve: "Вирішити",
  add_note: "Додати нотатку",
  save_note: "Зберегти нотатку",
  resolve_local_badge: "лише цей пристрій",
  resolve_local_hint: "Позначає сповіщення як вирішене лише у вашому браузері. Сервер та інші члени команди досі бачать його як відкрите.",
  note_placeholder: "Додайте контекст для команди…",
  notes_count: "{n} нотаток",
  device_detail: "Деталі пристрою",
  device_diagnostics: "Діагностика",
  device_firmware_history: "Історія прошивки",
  device_ota_config: "Конфігурація OTA",
  device_ota_status: "Статус OTA",
  device_signal: "Якість сигналу",
  device_mac: "MAC-адреса",
  device_serial: "Серійний номер",
  fall_sensitivity: "Чутливість виявлення падіння",
  transmission_interval: "Інтервал передачі",
  low_battery_threshold: "Поріг низького заряду",
  ota_idle: "Очікування",
  ota_pending: "Очікує",
  ota_deploying: "Розгортання",
  ota_failed: "Помилка",
  events_filter_severity: "Важливість",
  events_filter_room: "Кімната",
  events_filter_patient: "Пацієнт",
  events_filter_device: "Пристрій",
  severity_info: "Інфо",
  severity_warning: "Попередження",
  severity_critical: "Критичний",
  telegram_title: "Сповіщення Telegram",
  telegram_desc: "Отримуйте сповіщення в Telegram для призначених вам підопічних.",
  telegram_connect: "Підключити Telegram",
  telegram_connected: "Telegram підключено",
  telegram_connected_as: "Підключено до Telegram як {name}",
  telegram_connect_success: "Telegram успішно підключено",
  telegram_connect_error: "Не вдалося підключити Telegram. Спробуйте ще раз.",
  telegram_missing_bot: "Бот Telegram не налаштовано. Встановіть REACT_APP_TELEGRAM_BOT у файлі env.",
  telegram_disconnect: "Відключити",
  telegram_disconnect_success: "Telegram відключено.",
  telegram_disconnect_error: "Не вдалося відключити Telegram. Спробуйте ще раз.",
  telegram_already_linked: "Цей акаунт Telegram уже пов’язаний з іншим користувачем e2-care.",
  telegram_switch_q: "Використати інший акаунт Telegram?",
  telegram_switch_intro: "Telegram запам’ятовує, який акаунт увійшов на всіх сайтах. Щоб використати інший:",
  telegram_switch_step1: "Відкрийте Telegram Web і вийдіть із поточного акаунта.",
  telegram_switch_step2: "Поверніться сюди та перезавантажте кнопку нижче, потім увійдіть іншим акаунтом.",
  telegram_open_web: "Відкрити Telegram Web",
  telegram_reload_widget: "Я вийшов — перезавантажити кнопку",
  lang_autodetected_toast: "Виявлено вашу мову як {language}. Ви можете змінити її в Налаштуваннях.",
  admin_view_active: "Активні",
  admin_view_archived: "Заархівовані",
  admin_restore: "Відновити",
  admin_restored: "Відновлено.",
  admin_hard_delete: "Видалити назавжди",
  admin_hard_delete_title: "Видалити назавжди?",
  admin_hard_delete_confirm: "Це назавжди видалить «{name}» з бази даних. Цю дію не можна скасувати.",
  admin_hard_deleted: "Видалено назавжди.",
  admin_no_archived: "Немає заархівованих елементів.",
  language_desc: "Використовується для інтерфейсу застосунку та ваших сповіщень Telegram + push.",
  language_saved: "Мову оновлено.",
  language_error: "Не вдалося оновити мову. Спробуйте ще раз.",
  admin_field_language: "Мова",
  edit: "Редагувати",
  generic_error: "Щось пішло не так. Спробуйте ще раз.",
  caregiver_added: "Доглядальника додано.",
  caregiver_removed: "Доглядальника видалено.",
  family_added: "Члена родини додано.",
  family_removed: "Члена родини видалено.",
  menu: "Меню",
  dl_companion_app: "Супутній застосунок",
  dl_hero_title: "E2 Care для Android",
  dl_hero_sub: "Встановіть супутній застосунок на телефон із Moko, щоб ретранслювати сповіщення, налаштовувати пристрої та залишатися на зв’язку з командою догляду — навіть коли панель закрита.",
  dl_android_apk: "APK Android",
  dl_version_loading: "завантаження версії…",
  dl_released: "Випущено {date}",
  dl_download_apk: "Завантажити APK",
  dl_unavailable: "Недоступно",
  dl_preparing: "Підготовка…",
  dl_manifest_error: "Не вдалося завантажити маніфест. Спробуйте оновити — якщо проблема не зникає, сервер збірки може перерозгортатися.",
  dl_whats_new: "Що нового",
  dl_installing_title: "Встановлення на телефон",
  dl_step1: "Натисніть «Завантажити APK» вище. Ваш браузер може попередити, що файли APK можуть зашкодити пристрою — це попередження є нормальним для будь-якого інсталятора, завантаженого поза Play Store.",
  dl_step2: "Відкрийте завантажений файл. Android попросить дозволити встановлення з цього браузера вперше — увімкніть дозвіл і поверніться.",
  dl_step3: "Натисніть «Встановити», а потім «Відкрити» після завершення.",
  dl_step4: "Увійдіть за допомогою своїх облікових даних E2 Care.",
  dl_iphone_note: "Версія для iPhone з’явиться пізніше. Наразі скористайтеся вебпанеллю.",
  dl_back_to_dashboard: "Назад до панелі",
  dl_android_min: "Android {version}+",
  admin_device_org_change_hint: "Зміна організації очищає поточне призначення кімнати та пацієнта.",
  admin_view_full: "Повний список",
  device_filter_assignment: "Призначення",
  device_filter_patient: "Призначено пацієнту",
  device_filter_room: "Призначено кімнаті",
  device_filter_unassigned: "Не призначено",
  admin_all_orgs: "Усі організації",
  pagination_prev: "Попередня",
  pagination_next: "Наступна",
  pagination_per_page: "На сторінці",
  pagination_page_of: "Сторінка {page} з {pages}",
  pagination_total: "Усього {total}",
};
export default uk;
